import React from 'react';

const ArticleHero = ({ post }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr)?.toLocaleDateString('nb-NO', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  };

  const CATEGORY_COLORS = {
    'Nyheter': '#3B6FD4',
    'Veioppdateringer': '#2A9D8F',
    'Tips & Råd': '#E9C46A',
    'Teknologi': '#9B5DE5',
    'Sikkerhet': '#E76F51'
  };

  const categoryColor = CATEGORY_COLORS?.[post?.category] || '#3B6FD4';

  return (
    <div style={{ position: 'relative', height: '600px', overflow: 'hidden', marginTop: '72px' }}>
      <img
        src={post?.hero_image || 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1600&h=700&fit=crop'}
        alt={post?.hero_image_alt || post?.title}
        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 40%', filter: 'brightness(0.4) contrast(1.1)' }}
      />
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(5,10,18,1) 0%, rgba(5,10,18,0.5) 40%, transparent 100%)' }} />
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '100px', background: '#050A12', clipPath: 'polygon(0 100%, 100% 30%, 100% 100%)' }} />

      {/* Content overlay */}
      <div style={{ position: 'absolute', bottom: '80px', left: '6%', right: '6%', maxWidth: '900px' }}>
        {/* Category + date */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <span
            style={{
              background: categoryColor,
              padding: '4px 14px',
              fontFamily: 'Syne, sans-serif',
              fontSize: '0.65rem',
              fontWeight: 700,
              color: '#EEF0F2',
              letterSpacing: '0.2em',
              textTransform: 'uppercase'
            }}
          >
            {post?.category}
          </span>
          <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8rem', color: 'rgba(238,240,242,0.55)' }}>
            {formatDate(post?.published_at)}
          </span>
        </div>

        {/* Title */}
        <h1
          style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: 'clamp(1.8rem, 4vw, 3.5rem)',
            fontWeight: 800,
            color: '#EEF0F2',
            margin: 0,
            lineHeight: 1.1,
            letterSpacing: '-0.03em',
            maxWidth: '800px'
          }}
        >
          {post?.title}
        </h1>

        {/* Excerpt */}
        {post?.excerpt && (
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: '1.1rem',
              color: 'rgba(238,240,242,0.75)',
              marginTop: '16px',
              lineHeight: 1.6,
              maxWidth: '700px'
            }}
          >
            {post?.excerpt}
          </p>
        )}
      </div>
    </div>
  );
};

export default ArticleHero;
